import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_MULTIPLE_CHOICE,
  EXERCISE_MULTIPLE_CHOICE_OPTION,
  EXERCISE_MULTIPLE_CHOICE_OPTIONS,
  EXERCISE_MULTIPLE_CHOICE_QUESTION,
  EXERCISE_MULTIPLE_CHOICE_QUESTIONS,
  ExerciseMultipleChoiceOptions,
} from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { PARAGRAPH_TOGGLE } from '../../plugins-common/ParagraphToggle/types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const DoTestExerciseMultipleChoice = dynamicEditorComponent(() =>
  import('./components/readonly/DoTestExerciseMultipleChoice').then(
    (mod) => mod.DoTestExerciseMultipleChoice
  )
);
const DoTestExerciseMultipleChoiceQuestions = dynamicEditorComponent(
  () =>
    import('./components/readonly/DoTestExerciseMultipleChoiceQuestions').then(
      (mod) => mod.DoTestExerciseMultipleChoiceQuestions
    ),
  {
    dependsOn: DoTestExerciseMultipleChoice,
  }
);
const DoTestQuestion = dynamicEditorComponent(
  () => import('./components/readonly/DoTestQuestion').then((mod) => mod.DoTestQuestion),
  {
    dependsOn: DoTestExerciseMultipleChoice,
  }
);
const DoTestOption = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/readonly/DoTestOption').then((mod) => mod.DoTestOption),
    {
      dependsOn: DoTestQuestion,
    }
  )
);
const DoTestOptions = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/readonly/DoTestOptions').then((mod) => mod.DoTestOptions),
    {
      dependsOn: DoTestQuestion,
    }
  )
);
const ParagraphToggleOverrided = dynamicEditorComponent(
  () =>
    import('./components/readonly/ParagraphToggleOverrided').then(
      (mod) => mod.ParagraphToggleOverrided
    ),
  {
    dependsOn: DoTestExerciseMultipleChoice,
  }
);

const renderReadOnlyElementExerciseMultipleChoice = (options) => (props) => {
  const { onBackWhenInComplete } = options;
  const { element } = props;

  switch (element.type) {
    case PARAGRAPH_TOGGLE: {
      if (element.parentNodeType !== EXERCISE_MULTIPLE_CHOICE) return undefined;

      return <ParagraphToggleOverrided {...props} />;
    }

    case EXERCISE_MULTIPLE_CHOICE:
      return (
        <DoTestExerciseMultipleChoice {...props} onBackWhenInComplete={onBackWhenInComplete} />
      );

    case EXERCISE_MULTIPLE_CHOICE_QUESTIONS:
      return <DoTestExerciseMultipleChoiceQuestions {...props} />;

    case EXERCISE_MULTIPLE_CHOICE_QUESTION:
      return <DoTestQuestion {...props} />;

    case EXERCISE_MULTIPLE_CHOICE_OPTIONS:
      return <DoTestOptions {...props} />;

    case EXERCISE_MULTIPLE_CHOICE_OPTION:
      return <DoTestOption {...props} />;

    default:
      return undefined;
  }
};

export const ExerciseMultipleChoiceReadOnlyPlugin = (
  options?: ExerciseMultipleChoiceOptions
): SlatePlugin => ({
  renderElement: renderReadOnlyElementExerciseMultipleChoice(options),
});
